import { PATHS } from 'config/paths';
import { getTrans } from 'modules/i18n';
import { ErrorScreen } from '../parts/ErrorScreen';

export const ErrorFallbackScreen = () => (
  <ErrorScreen
    title={getTrans('crashScreen.title1')}
    description1={getTrans('crashScreen.body1')}
    description2={getTrans('crashScreen.body2')}
    buttonText={getTrans('crashScreen.buttonTitle')}
    buttonLink={PATHS.root}
  />
);
